import { createSlice } from "@reduxjs/toolkit";
// import _formatMessage from "format-message";
import EnJS from './../translations/en'
import FrJS from './../translations/fr'
import DeJS from './../translations/de'
const localState = {
  _locale: 'en',
  translations: EnJS,
  language: "",
  languageName: "",
};
export const LocalSlice = createSlice({
  name: "local",
  initialState: localState,
  reducers: {
    setLocale: (state, action) => {
      state.languageName = action.payload.language;
      state._locale = action.payload._locale;
    },
    setTranslations: (state,{payload}) => {
      state.translations = payload === 'en' ? EnJS : payload === 'de' ? DeJS : FrJS;
      state._locale = payload;
    },
 
    // formatMessage :(id, values) => {
    //     if (!(id in this.messages)) {
    //       return id;
    //     }
    //     return _formatMessage(this.messages[id], values);
    //   }
  },
});

export const { setLocale,setTranslations } = LocalSlice.actions;
export default LocalSlice.reducer;
